import { mutator } from 'satcheljs';
import onSmimeItemEncodeFailed from 'owa-smime/lib/actions/onSmimeItemEncodeFailed';
import findComposeViewStateById, { IdSource } from '../utils/findComposeViewStateById';

/**
 * Mutator that sets the S/MIME error code and context in smimeViewState
 * in case S/MIME encoding is failed.
 */
export default mutator(onSmimeItemEncodeFailed, actionMessage => {
    const { composeId, errorCode, errorContext } = actionMessage;
    const viewState = findComposeViewStateById(composeId, IdSource.Compose);
    if (viewState && viewState.smimeViewState) {
        const { smimeViewState } = viewState;
        smimeViewState.errorCode = errorCode;
        smimeViewState.errorContext = errorContext;
    }
});
